import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Col,
    Spinner,
} from 'reactstrap';
import { authenticate } from './dispatcher';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authError = useSelector(state => state?.authReducer?.error);
    const loading = useSelector(state => state?.authReducer?.isLoading);


    const handleLogin = async (e) => {
        e.preventDefault();
        const data = {
            emailId: email,
            password: password
        };
        dispatch(authenticate(data, navigate));
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && email && password) {
            handleLogin(e);
        }
    };

    return (
        <Col lg="5" md="7" >
            <div style={{
                // background: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '16px',
                padding: '20px',
                // boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                // backdropFilter: 'blur(5px)',
                // WebkitBackdropFilter: 'blur(5px)',
                // border: '1px solid rgba(255, 255, 255, 0.3)'
            }}>
                <Form role="form" onKeyPress={handleKeyPress}>
                    <FormGroup className="mb-4">
                        <InputGroup style={{
                            background: 'rgba(255, 255, 255, 0.6)',
                            borderRadius: '12px',
                            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.4)',
                            overflow: 'hidden'
                        }}>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText style={{
                                    background: 'transparent',
                                    border: 'none',
                                    paddingLeft: '15px'
                                }}>
                                    <i className="ni ni-email-83" style={{ color: '#26632b', fontSize: '18px' }} />
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '15px',
                                    color: '#333',
                                    paddingLeft: '10px'
                                }}
                                placeholder="Email"
                                type="email"
                                autoComplete="new-email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </InputGroup>
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <InputGroup style={{
                            background: 'rgba(255, 255, 255, 0.6)',
                            borderRadius: '12px',
                            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.4)',
                            overflow: 'hidden'
                        }}>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText style={{
                                    background: 'transparent',
                                    border: 'none',
                                    paddingLeft: '15px'
                                }}>
                                    <i className="ni ni-lock-circle-open" style={{ color: '#26632b', fontSize: '18px' }} />
                                </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '15px',
                                    color: '#333',
                                    paddingLeft: '10px'
                                }}
                                placeholder="Password"
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="new-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {password && (
                                <InputGroupAddon addonType="append">
                                    <InputGroupText
                                        onClick={togglePasswordVisibility}
                                        style={{
                                            cursor: 'pointer',
                                            background: 'transparent',
                                            border: 'none',
                                            paddingRight: '15px'
                                        }}
                                    >
                                        <i className={`fa fa-eye${showPassword ? '' : '-slash'}`} style={{ color: '#26632b', fontSize: '16px' }} />
                                    </InputGroupText>
                                </InputGroupAddon>
                            )}
                        </InputGroup>
                    </FormGroup>

                    <div className="text-center mt-2">
                        <br />
                        <button
                            style={{
                                padding: "12px 40px",
                                background: "#26632b",
                                color: "white",
                                borderRadius: "10px",
                                border: "none",
                                fontSize: "16px",
                                fontWeight: "500",
                                cursor: loading || !email || !password ? 'not-allowed' : 'pointer',
                                opacity: loading || !email || !password ? 0.6 : 1,
                                boxShadow: '0 4px 15px rgba(38, 99, 43, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            type="button"
                            onClick={handleLogin}
                            disabled={loading || !email || !password}
                            onMouseEnter={(e) => {
                                if (!loading && email && password) {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(38, 99, 43, 0.4)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(38, 99, 43, 0.3)';
                            }}
                        >
                            {loading ? <Spinner size="sm" /> : 'Sign in'}
                        </button>
                    </div>
                </Form>
            </div>
        </Col>
    );
};

export default Login;
